<template>
    <div v-if="required" class="col-12 px-0 form-group">                    
        <label for="dateOfBirth" class="col-12 px-0">{{labels.dateOfBirth}}</label>
        <div class="input-group">
            <input type="tel" id="dateOfBirth" aria-required="true" name="dateOfBirth" aria-label="Date of Birth mm/dd/yyyy" class="form-control" maxlength="10" v-bind:class="{'error': onDobError}" v-model="maskedValue" v-maska="maskValue" :placeholder="placeholder" @blur="onDobBlur">
            <div class="input-group-append" @click="toggleDisplay">
                <a class="input-group-text icon-button" aria-hidden="true">
                    <fa-icon v-if="!shown" :icon="['far','calendar-alt']" class="theme-primary" />
                    <fa-icon v-else :icon="['far','calendar-times']" class="theme-primary" />
                    <span class="sr-only">show/hide calendar</span>
                </a>
            </div>
        </div>
        <datepicker v-if="shown" aria-hidden="true" v-model="dataValue" inline auto-apply :max-date="maxDate" :enable-time-picker="false" @update:model-value="shown = false"></datepicker>
        <p v-if="onDobError" class="error-msg mt-1 mb-2" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{labels.requiredEntry}}</p>
    </div>
</template>

<script>
    import Datepicker from '@vuepic/vue-datepicker';

    export default {
        name: "DateOfBirth",

        emits: ['set-date-of-birth'],

        components: {
            Datepicker
        },

        props: {
            labels: Object,
            required: Boolean
        },

        data: function() {
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            return {
                dataValue: null,
                maskedValue: "",
                maskValue: "##/##/####",
                placeholder: "mm/dd/yyyy",
                maxDate: tomorrow,
                shown: false,
                onDobError: false
            }
        },

        methods: {
            getFormattedDateString: function() {
                var dateString = "";

                if (this.dataValue !== null) {
                    dateString = this.getMonth() + "/" + this.getDate() + "/" + this.dataValue.getFullYear();
                }
                
                return dateString;
            },

            getMonth: function() {
                var month = this.dataValue.getMonth() + 1;

                if (month < 10) {
                    month = "0" + month;
                }

                return month;
            },

            getDate: function() {
                var date = this.dataValue.getDate();

                if (date < 10) {
                    date = "0" + date;
                }

                return date;
            },

            toggleDisplay: function() {
                this.shown = !this.shown;
            },

            onDobBlur: function(){
                this.onDobError = this.maskedValue === "";
                return this.onDobError;
            }
        },

        watch: {
            dataValue: function(val) {
                var value = this.getFormattedDateString();
                this.$emit('set-date-of-birth', value);
                this.maskedValue = value;
            },

            maskedValue: function(val) {
                this.onDobError = false;
                if (val.length === 10) {
                    this.dataValue = new Date(val);
                }
                else {
                    this.dataValue = null;
                }
            }
        }
    }
</script>

<style>
    .form-control[readonly] {
        background: #ffffff;
    }

    [data-datepicker-instance] {
        z-index: 9999;
    }

    [data-datepicker-instance] .dp__outer_menu_wrap {
        position: absolute;
    }
</style>